import { ModuleWithProviders, NgModule } from '@angular/core';
import { AllowNumbersDirective } from './allow-numbers.directive';
import { TextboxDirective } from './textbox.directive';
import { IfDirective } from './if.directive';
import { TxtDirective } from './txt.directive';
import { MLMTextDirective } from './mlm-text.directive';
import { MaximumLengthDirective } from './max-length.directive';
import { ValidateDropdownDirective } from './drop-down.directive';
import { DblClickDisableDirective } from './double-click-disable.directive';

@NgModule({
  imports: [
  ],
  declarations: [
    AllowNumbersDirective,
    TextboxDirective,
    IfDirective,
    TxtDirective,
    MLMTextDirective,
    MaximumLengthDirective,
    ValidateDropdownDirective,
    DblClickDisableDirective
  ],
  providers: [
  ],
  exports: [
    AllowNumbersDirective,
    TextboxDirective,
    IfDirective,
    TxtDirective,
    MLMTextDirective,
    MaximumLengthDirective,
    ValidateDropdownDirective,
    DblClickDisableDirective
  ]
})
export class CustomDirectiveModule {
  static forRoot(): ModuleWithProviders<CustomDirectiveModule> {
    return { ngModule: CustomDirectiveModule };
  }
}
